const getTerritoryPageUrl = (territorySlug: string): string => `/t/${territorySlug}/explore`;

export default getTerritoryPageUrl;
